import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Button from "components/common/Button";
import GiftIcon from "assets/svgs/GiftIcon";
import CreditCardIcon from "assets/svgs/CreditCardIcon";

import {
  currencyFormat,
  getCountryFlag,
  getFieldValue,
  getProfileImage,
  getSalaryWithoutBonusAndIncrement,
  getSalaryWithoutBouns,
  isEmptyObject,
} from "components/Screens/CommonUtils";

import { s3ImagesBaseURL } from "util/APIBaseUrl";

import { EMPLOYEE_DETAILS_ROUTE } from "constants/routes";

import { Avatar, CardMedia } from "@mui/material";

import avatarImage from "assets/images/fallback-image.svg";

import "./EmployeePayrollCardV2.scss";

function EmployeePayrollCardV2({ employee }) {
  const navigate = useNavigate();
  const [imageSrc, setImageSrc] = useState(avatarImage);

  const {
    picturePath,
    pictureVersion,
    id: employeeId,
    costToCompany,
    incrementDetails,
    name,
    role,
    edgeJoiningDate,
    bonus,
    country,
  } = employee || {};
  const { incrementAmount: incrementAmountFromDetails, bonus: bonusFromDetails } = incrementDetails || {};

  useEffect(() => {
    if (isEmptyObject(employee) && picturePath) {
      getProfileImage(employeeId, pictureVersion).then((img) => {
        setImageSrc(img);
      });
    } else {
      setImageSrc(avatarImage);
    }
  }, [employee]);

  const handleViewProfile = () => {
    navigate(EMPLOYEE_DETAILS_ROUTE.replace(":employeeId", employeeId));
  };

  const salaryWithoutBonus = getSalaryWithoutBouns(costToCompany, bonusFromDetails);
  const baseSalary = getSalaryWithoutBonusAndIncrement(costToCompany, incrementAmountFromDetails, bonusFromDetails);
  const incrementAmount = getFieldValue(incrementAmountFromDetails);
  const cardImage = imageSrc[employeeId] ? imageSrc[employeeId] : `${s3ImagesBaseURL}/placeholder-avatar.svg`;

  return (
    <div className="employee-payroll-card-v2">
      <div className="employee-card-v2-main">
        <div className="employee-info-container">
          <div className="employee-card-v2-avatar-section">
            <CardMedia component="img" image={cardImage} alt={name} className="employee-card-v2-avatar" />
            <Avatar
              sx={{
                width: "26px",
                height: "26px",
                background: "#FFFFFF",
                borderRadius: "99px",
                position: "absolute",
                bottom: "4px",
                left: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              id="emp-country"
            >
              {getCountryFlag(country)}
            </Avatar>
          </div>
          <div className="employee-card-v2-info">
            <div className="employee-card-column-name">{name}</div>
            <div className="employee-card-v2-details">
              <div className="employee-card-sub-heading">{role}</div>
              <div className="para-body-s-regular color-text-body-secondary">{edgeJoiningDate}</div>
            </div>
          </div>
        </div>
        <div className="employee-card-v2-salary-details">
          <div className="employee-card-v2-salary-item">
            <div className="employee-card-column-name">Charges</div>
            <div className="employee-card-v2-value-section">
              <div className="employee-card-v2-value">
                <CreditCardIcon color="#484649" />${currencyFormat(salaryWithoutBonus)}
              </div>
              <div className="employee-card-sub-heading">
                ${currencyFormat(baseSalary)} + ${currencyFormat(incrementAmount)}
              </div>
            </div>
          </div>
          <div className="employee-card-v2-salary-item">
            <div className="employee-card-column-name">Bonus</div>
            <div className="employee-card-v2-value-section">
              <div className="employee-card-v2-value">
                <GiftIcon />${currencyFormat(getFieldValue(bonus))}
              </div>
            </div>
          </div>
          <div className="employee-card-v2-actions">
            <Button
              variant="outlined"
              className="employee-card-v2-actions-button"
              size="sm"
              onClick={handleViewProfile}
              label="View Profile"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployeePayrollCardV2;
